module.exports = __webpack_public_path__ + "img/3ds.d10cc9e6.png";